import { render, staticRenderFns } from "./tabTable.vue?vue&type=template&id=e012dc9e&"
import script from "./tabTable.vue?vue&type=script&lang=ts&"
export * from "./tabTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports